/*Package importing*/
import React, { useState, useEffect } from 'react';

/*Import custom components and assets*/
import SetPassword from './setPassword';
import logo from '../../assets/images/logo.png';
import loginHero from '../../assets/images/login-hero.svg';



const SetAdminPassword = () => {
    const [tempToken, setTempToken] = useState("");

    useEffect(() => {
        const temp_token = window.location.href.split("=")[1];
        if (temp_token) {
            setTempToken(temp_token);
        }
    }, []);

    const passwordSet = (response) => {
        window.location.href = '/';
    };

    return (
        <div className="e-body">
            <section className="e-login-section vh-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center mt-5">
                            <img src={logo} alt="Tranna admin logo" className="e-logo mt-5" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 offset-lg-3">
                            {
                                <SetPassword token={tempToken}
                                    passwordSet={passwordSet} />
                            }
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default SetAdminPassword;